<template>
  <div class="form-row justify-content-center mx-auto my-2 ">
    <div class="col-xl-12 col-lg-12 col-md-12 col-xs-12 col-sm-12">
      <label class="small text-secondary required">Número do cartão</label>
      <div class="input-group">
        <input
          type="text"
          v-model="formulario.numero"
          @input="determinarBandeiraDoCartao"
          class="form-control form-control-md corBordaCampo placeholder"
          maxlength="50"
          autocomplete="cc-number"
          v-mask="'#### #### #### ####'"
          :disabled="desabilitarCampos"
        />
        <div class="input-group-append" v-if="formulario.bandeira">
          <span class="bandeira-cartao"
            ><b-img
              :blank="!formulario.bandeira"
              v-if="formulario.bandeira"
              :src="obterBandeiraInputLocal(formulario.bandeira)"
              :fluid="true"
              alt="bandeira cartão de crédito"
              width="30"
              class="mr-1 text-right"
          /></span>
        </div>
      </div>
      <div class="avisoDanger text-left">
        {{listaDeErros['cartao.numero']}}
      </div>
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12 col-xs-12 col-sm-12 form-group">
      <label class="small text-secondary required"
        >Nome impresso no cartão</label
      >
      <input
        type="text"
        autocomplete="cc-name"
        v-model="formulario.nome"
        class="form-control form-control-md corBordaCampo placeholder"
        maxlength="50"
        :disabled="desabilitarCampos"
      />
      <div class="avisoDanger text-left">
        {{listaDeErros['cartao.nome']}}
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-xs-12 col-sm-12 form-group">
      <label class="small text-secondary required">Data Expiração</label>
      <input
        v-model="formulario.validade"
        type="text"
        autocomplete="cc-exp"
        v-mask="'##/####'"
        placeholder="MM/AAAA"
        class="form-control form-control-md corBordaCampo placeholder"
        maxlength="50"
        :disabled="desabilitarCampos"
      />
      <div class="avisoDanger text-left">
        {{listaDeErros['cartao.validade']}}
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-xs-12 col-sm-12 form-group">
      <label class="small text-secondary required">CCV</label>
      <input
        v-model="formulario.ccv"
        type="password"
        autocomplete="cc-csc"
        v-mask="'####'"
        class="form-control form-control-md corBordaCampo placeholder"
        maxlength="50"
        :disabled="desabilitarCampos"
      />
      <div class="avisoDanger text-left">
        {{listaDeErros['cartao.ccv']}}
      </div>
    </div>
  </div>
</template>

<script>
import Credito from './js/formulario-credito'
export default Credito
</script>

<style scoped>
@import "./scss/formulario-credito.scss";
</style>
